import styled from "styled-components";

const FormError = styled.div`
  background-color: ${({ theme }) => theme.colors.error};
  font-weight: 700;
  color: white;
  padding: 1rem;
  border-radius: 2px;
  margin-bottom: 1.5rem;
`;

export default FormError;
